"use client";
import * as React from "react";
const SvgLiveTvOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.818 5.6v5.6l5.091-2.8-5.09-2.8Zm8.728-2.8H9.033L11.426.497 10.909 0 8 2.8h-.022L5.07 0l-.502.497L6.953 2.8H1.455C.655 2.8 0 3.43 0 4.2v8.4c0 .77.655 1.4 1.455 1.4h13.09c.8 0 1.455-.63 1.455-1.4V4.2c0-.77-.655-1.4-1.454-1.4Zm0 9.8H1.455V4.2h13.09v8.4Z" }));
export {
  SvgLiveTvOutlined as default
};
